"use client";
import Link from "next/link";
import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { IoImageOutline } from "react-icons/io5";
import useFetch from "@/app/useFetch";
import { IMG_URL } from "@/app/config";
import { useTheme } from "@/app/theme-provider";
import Pegination from "./Pegination";

const Gallery2 = () => {
  const { language } = useTheme()
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [key, setKey] = useState("photo");

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(12);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // const { data: list, loading, error } = useFetch(
  //   key === "photo" ? "/website/gallery-albums" : "/website/gallery-video",
  //   [key]
  // );

  const { data: list = [], totalPages, loading, error } = useFetch(
    key === "photo" ? "/website/gallery-albums" : "/website/gallery-video",
    {
      page: currentPage,
      limit: limit,
      search: debouncedSearch,
    },
    [debouncedSearch, currentPage, limit, key]
  );

  const getYoutubeThumbnail = (url) => {
    const match = url?.match(/v=([^&]+)/);
    return match
      ? `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`
      : "/images/default-thumb.jpg";
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="tabs-container mt-40">
        <Tabs
          id="section-tabs"
          activeKey={key}
          onSelect={(k) => {
            setKey(k);
            setCurrentPage(1);
          }}
          className="custom-tabs"
        >
          {/* ---------- PHOTO TAB ---------- */}
          <Tab eventKey="photo" title={language == "en" ? "Photos" : "ഫോട്ടോകൾ"} className="mt-40">
            <div className="row g-3 g-md-4 gallery-list-row">
              {list?.map((item, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <Link
                    href={`/gallery/${item.permalink}`}
                    className="text-decoration-none"
                  >
                    <div className="gallery-card">
                      <img
                        src={`${IMG_URL}${item.photo}`}
                        alt={item.description}
                        className="img-fluid rounded"
                        loading="lazy"
                      />
                      <div className="gallery-text">{item.name}</div>
                      <span className="image-icon-gallery-span">
                        <IoImageOutline className="icon-gallery" />
                      </span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
            {totalPages > 1 && (
                    <Pegination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
          </Tab>

          {/* ---------- VIDEO TAB ---------- */}
          <Tab eventKey="video" title={language == "en" ? "Videos" : "വീഡിയോകൾ"} className="mt-40">
            <div className="row g-3 g-md-4 gallery-list-row">
              {list?.length > 0 ? (
                list.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    {/* YouTube video */}
                    {item.type === "youtube" ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="gallery-card">
                          <img
                            loading="lazy"
                            src={getYoutubeThumbnail(item.link)}
                            alt={item.name}
                          />
                          <div className="gallery-text">{item.name}</div>
                          <img
                            className="gallery-youtube"
                            src="/icons/youtue1.svg"
                            alt="YouTube Icon"
                          />
                        </div>
                      </a>
                    ) : (
                      // Local uploaded video → open modal
                      <div
                        className="gallery-card cursor-pointer"
                        onClick={() => setSelectedVideo(item)}
                      >
                        <img
                          loading="lazy"
                          src={`${IMG_URL}${item.thumbnail}`}
                          alt={item.name}
                        />
                        <div className="gallery-text">{item.name}</div>
                        <img
                          className="gallery-youtube"
                          src="/icons/youtue1.svg"
                          alt="Play Icon"
                        />
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No videos found</p>
              )}
            </div>
            {totalPages > 1 && (
                    <Pegination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}

            {/* ---------- Video Modal ---------- */}
            {selectedVideo && (
              <div className="video-modal">
                <div className="video-modal-content">
                  <button
                    className="close-btn"
                    onClick={() => setSelectedVideo(null)}
                  >
                    ✖
                  </button>

                  <video
                    controls
                    autoPlay
                    className="rounded gallery-modal-video"
                  >
                    <source
                      src={`${IMG_URL}${selectedVideo.videofile}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>

                {/* Backdrop */}
                <div
                  className="video-backdrop"
                  onClick={() => setSelectedVideo(null)}
                ></div>
              </div>
            )}
          </Tab>
        </Tabs>
      </div>

      <style jsx>{`
        .video-modal {
          position: fixed;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1050;
        }
        .video-modal-content {
          position: relative;
          background: #000;
          padding: 10px;
          border-radius: 10px;
          z-index: 2;
          max-width: 90%;
          width: 800px;
        }
        .gallery-modal-video {
          width: 100%;
          max-height: min(70vh, 400px);
          aspect-ratio: 16 / 9;
          object-fit: contain;
        }
        .video-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.7);
          z-index: 1;
        }
        .close-btn {
          position: absolute;
          top: 10px;
          right: 15px;
          color: white;
          background: transparent;
          border: none;
          font-size: 25px;
          cursor: pointer;
        }
        @media (max-width: 575px) {
          .video-modal-content {
            max-width: calc(100% - 24px);
            padding: 8px;
          }
        }
      `}</style>
    </>
  );
};

export default Gallery2;
